// src/components/lodging-offer-filters/lodging-offer-filters.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment FilterBasicPillAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment FilterBasicPillFragment on EGDSBasicPill {\n    id\n    primary\n    selected\n    accessibility\n    selectAnalytics {\n      ...FilterBasicPillAnalyticsFragment\n    }\n    deselectAnalytics {\n      ...FilterBasicPillAnalyticsFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingOfferFiltersFragment on LodgingOfferFilters {\n    heading {\n      text\n      accessibility\n    }\n    impressionTracking {\n      ...FilterBasicPillAnalyticsFragment\n    }\n    filterPills {\n      ...FilterBasicPillFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import React2 from "react";
import { gql } from "@apollo/client";
import { UitkLayoutGrid, UitkLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSPill, EGDSPillContainer } from "@egds/react-core/pill";
import { UitkSpacing } from "@egds/react-core/spacing";
import { UitkText } from "@egds/react-core/text";
import { Level, liveAnnounce } from "@egds/react-core/utils";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useViewportMap, ViewSizes } from "@shared-ui/viewport-context";
// src/utils/populate-string-template.ts
var populateStringTemplate = function(template, replaceMap) {
    var interpolatedMessage = template;
    Object.keys(replaceMap).forEach(function(key) {
        var value = replaceMap[key].toString();
        interpolatedMessage = interpolatedMessage.replaceAll("${".concat(key, "}"), value.toString());
    });
    return interpolatedMessage;
};
// src/components/lodging-offer-filters/context/context-builder.tsx
import React from "react";
// src/components/lodging-offer-filters/context/reducer.ts
var actions = {
    SINGLE_SELECT_PILL: "single_select_pill",
    SINGLE_UNSELECT_PILL: "single_unselect_pill"
};
var cloneAndResetSelected = function(arr) {
    return arr.map(function(pill) {
        switch(pill.__typename){
            case "EGDSBasicPill":
                return _object_spread_props(_object_spread({}, pill), {
                    selected: false
                });
            default:
                return _object_spread({}, pill);
        }
    });
};
function findClickedPill(action, updatedState) {
    return updatedState.find(function(pill) {
        return pill.__typename === "EGDSBasicPill" ? pill.id === action.payload.pill.id : false;
    });
}
var reducer = function(state, action) {
    switch(action.type){
        case actions.SINGLE_SELECT_PILL:
            {
                var updatedState = cloneAndResetSelected(state);
                var clickedPill = findClickedPill(action, updatedState);
                if ((clickedPill === null || clickedPill === void 0 ? void 0 : clickedPill.__typename) === "EGDSBasicPill") {
                    clickedPill.selected = true;
                }
                return updatedState;
            }
        case actions.SINGLE_UNSELECT_PILL:
            {
                var updatedState1 = cloneAndResetSelected(state);
                var firstPill = updatedState1.find(Boolean);
                var clickedPill1 = findClickedPill(action, updatedState1);
                if ((clickedPill1 === null || clickedPill1 === void 0 ? void 0 : clickedPill1.__typename) === "EGDSBasicPill") {
                    clickedPill1.selected = false;
                }
                if ((firstPill === null || firstPill === void 0 ? void 0 : firstPill.__typename) === "EGDSBasicPill") {
                    firstPill.selected = true;
                }
                return updatedState1;
            }
        default:
            return state;
    }
};
// src/components/lodging-offer-filters/context/context-builder.tsx
var collectActiveFilters = function(filterPills) {
    return filterPills.reduce(function(collectedFilters, pill) {
        if (pill.__typename === "EGDSBasicPill" && pill.selected && pill.id) {
            collectedFilters.push(pill.id);
        }
        return collectedFilters;
    }, []);
};
var createFilterContext = function(filterCallback) {
    var defaultState = {
        list: null,
        filteredList: null,
        filterPills: [],
        dispatchAction: /* istanbul ignore next -- @preserve */ function(action) {
            return void 0;
        }
    };
    var Context = React.createContext(defaultState);
    var useFiltersContext = function() {
        return React.useContext(Context);
    };
    var FiltersProvider = function(param) {
        var children = param.children, value = param.value;
        var list = value.list, filters = value.filters;
        var _React_useReducer = _sliced_to_array(React.useReducer(reducer, filters || []), 2), filterPills = _React_useReducer[0], dispatchAction = _React_useReducer[1];
        var _React_useState = _sliced_to_array(React.useState(list), 2), filteredList = _React_useState[0], setFilteredList = _React_useState[1];
        var _React_useState1 = _sliced_to_array(React.useState(collectActiveFilters(filterPills)), 2), activeFilters = _React_useState1[0], setActiveFilters = _React_useState1[1];
        React.useEffect(function() {
            var activeFiltersUpdated = collectActiveFilters(filterPills);
            setActiveFilters(activeFiltersUpdated);
        }, [
            filterPills
        ]);
        React.useEffect(function() {
            var filtered = activeFilters.length > 0 && list && list.length > 0 ? list.filter(function(item) {
                return filterCallback(item, activeFilters);
            }) : list;
            setFilteredList(filtered);
        }, [
            activeFilters,
            list
        ]);
        var providerValue = React.useMemo(function() {
            return {
                list: list,
                filteredList: filteredList,
                filterPills: filterPills,
                dispatchAction: dispatchAction
            };
        }, [
            list,
            filteredList,
            filterPills,
            dispatchAction
        ]);
        return /* @__PURE__ */ React.createElement(Context.Provider, {
            value: providerValue
        }, children);
    };
    return {
        Provider: FiltersProvider,
        useFiltersContext: useFiltersContext
    };
};
// src/components/lodging-offer-filters/context/filters-context.ts
var filter = function(listing, filters) {
    switch(listing.__typename){
        case "LodgingCategorizedUnit":
            var _listing_primarySelections;
            return ((_listing_primarySelections = listing.primarySelections) === null || _listing_primarySelections === void 0 ? void 0 : _listing_primarySelections.some(function(param) {
                var propertyUnit = param.propertyUnit;
                return filters.some(function(filterId) {
                    var _propertyUnit_matchingFilterIds;
                    return (_propertyUnit_matchingFilterIds = propertyUnit.matchingFilterIds) === null || _propertyUnit_matchingFilterIds === void 0 ? void 0 : _propertyUnit_matchingFilterIds.includes(filterId);
                });
            })) || false;
        default:
            return true;
    }
};
var _createFilterContext = createFilterContext(filter), PropertyOffersFiltersProvider = _createFilterContext.Provider, usePropertyOffersFiltersContext = _createFilterContext.useFiltersContext;
// src/components/lodging-offer-filters/lodging-offer-filters.tsx
var analyticsFragment = gql(_templateObject());
var basicPillFragment = gql(_templateObject1(), analyticsFragment);
var fragment = gql(_templateObject2(), analyticsFragment, basicPillFragment);
var LodgingOfferFilters = function(param) {
    var data = param.data;
    var _data_heading, _data_heading1;
    var _usePropertyOffersFiltersContext = usePropertyOffersFiltersContext(), filteredList = _usePropertyOffersFiltersContext.filteredList, filterPills = _usePropertyOffersFiltersContext.filterPills, dispatchAction = _usePropertyOffersFiltersContext.dispatchAction;
    var track = useClickTracker();
    var _React2_useState = _sliced_to_array(React2.useState(false), 2), isClientFiltered = _React2_useState[0], setIsClientFiltered = _React2_useState[1];
    var _obj;
    var isSmallViewport = useViewportMap((_obj = {}, _define_property(_obj, ViewSizes.SMALL, true), _define_property(_obj, ViewSizes.MEDIUM, false), _obj));
    var a11yHeader = data === null || data === void 0 ? void 0 : (_data_heading = data.heading) === null || _data_heading === void 0 ? void 0 : _data_heading.accessibility;
    var headerTemplate = (data === null || data === void 0 ? void 0 : (_data_heading1 = data.heading) === null || _data_heading1 === void 0 ? void 0 : _data_heading1.text) || "";
    var categorizedUnits = filteredList === null || filteredList === void 0 ? void 0 : filteredList.filter(function(item) {
        return item.__typename === "LodgingCategorizedUnit";
    });
    var headerText = populateStringTemplate(headerTemplate, {
        displayCount: (categorizedUnits === null || categorizedUnits === void 0 ? void 0 : categorizedUnits.length) || 0
    });
    React2.useEffect(function() {
        if (headerText && isClientFiltered) {
            liveAnnounce(headerText, Level.POLITE);
            setTimeout(function() {
                return liveAnnounce("", Level.POLITE);
            }, 1e3);
        }
    }, [
        filteredList,
        isClientFiltered
    ]);
    if (!data || filterPills.length === 0) {
        return null;
    }
    var impressionTracking = data.impressionTracking;
    var handleBasicPillChange = function(pill) {
        if (pill.selected) {
            dispatchAction({
                type: actions.SINGLE_UNSELECT_PILL,
                payload: {
                    pill: pill
                }
            });
            setIsClientFiltered(true);
            if (pill.deselectAnalytics) {
                var _pill_deselectAnalytics = pill.deselectAnalytics, referrerId = _pill_deselectAnalytics.referrerId, linkName = _pill_deselectAnalytics.linkName;
                track(referrerId, linkName);
            }
        } else {
            dispatchAction({
                type: actions.SINGLE_SELECT_PILL,
                payload: {
                    pill: pill
                }
            });
            setIsClientFiltered(true);
            if (pill.selectAnalytics) {
                var _pill_selectAnalytics = pill.selectAnalytics, referrerId1 = _pill_selectAnalytics.referrerId, linkName1 = _pill_selectAnalytics.linkName;
                track(referrerId1, linkName1);
            }
        }
    };
    var pills = filterPills === null || filterPills === void 0 ? void 0 : filterPills.map(function(pill, idx) {
        if (pill.__typename === "EGDSBasicPill") {
            var id = pill.id, selected = pill.selected, primary = pill.primary, accessibility = pill.accessibility;
            return /* @__PURE__ */ React2.createElement(EGDSPill, {
                id: id || "",
                checked: selected,
                altText: accessibility || "",
                onChange: function() {
                    return handleBasicPillChange(pill);
                },
                key: idx
            }, primary);
        }
        return null;
    });
    var _impressionTracking_referrerId, _impressionTracking_linkName;
    var trackingProps = {
        referrerId: (_impressionTracking_referrerId = impressionTracking === null || impressionTracking === void 0 ? void 0 : impressionTracking.referrerId) !== null && _impressionTracking_referrerId !== void 0 ? _impressionTracking_referrerId : "",
        linkName: (_impressionTracking_linkName = impressionTracking === null || impressionTracking === void 0 ? void 0 : impressionTracking.linkName) !== null && _impressionTracking_linkName !== void 0 ? _impressionTracking_linkName : ""
    };
    return /* @__PURE__ */ React2.createElement(UitkSpacing, {
        margin: {
            block: "three"
        }
    }, /* @__PURE__ */ React2.createElement(IntersectionTracker, _object_spread({}, trackingProps), /* @__PURE__ */ React2.createElement(UitkLayoutGrid, {
        columns: isSmallViewport ? 1 : [
            "auto",
            "max-content"
        ],
        alignItems: "center",
        space: "three"
    }, a11yHeader && /* @__PURE__ */ React2.createElement("span", {
        className: "is-visually-hidden"
    }, a11yHeader), /* @__PURE__ */ React2.createElement(EGDSPillContainer, null, pills), /* @__PURE__ */ React2.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React2.createElement(UitkText, {
        whiteSpace: "nowrap"
    }, headerText)))));
};
LodgingOfferFilters.displayName = "PropertyFilterPills";
LodgingOfferFilters.fragment = fragment;
export { LodgingOfferFilters, PropertyOffersFiltersProvider, usePropertyOffersFiltersContext };
//# sourceMappingURL=index.js.map